import { Injectable } from '@angular/core';
import { StoredCachedService } from '../../../driver/storage/models/stored-cached-service';
import { map, Observable } from 'rxjs';
import { UserStateService } from 'src/app/user-state/user-state.service';
import { CachedServiceRepositoryCacheManager } from '../../cache-manager/cached-service-repository-cache-manager';

/**
 * Operation class that gets all cached service entries from the repository as stored cached data.
 */
@Injectable({
	providedIn: 'root'
})
export class GetAllCachedServicesOperation {

	/**
	 * @constructor
	 * @param cachedServiceRepositoryCacheManager Cache manager used to interact with the CachedServiceRepository
	 * @param userStateService Service to access the current user's state.
	 */
	constructor(
		private readonly cachedServiceRepositoryCacheManager: CachedServiceRepositoryCacheManager,
		private readonly userStateService: UserStateService
	) { }

	/**
	 * Executes the operation to retrieve all cached services.
	 * @returns Observable emitting an array of StoredCachedService.
	 */
	public Execute$(): Observable<StoredCachedService[]> {
		return this.cachedServiceRepositoryCacheManager.GetAll$().pipe(
			map((storedCachedServices: StoredCachedService[]) => {
				return storedCachedServices.filter(service => {
					return service.UserName === this.userStateService.State.Username &&
						service.CrownId === this.userStateService.State.CrownIdentifier;
				});
			})
		);
	}
}
